import React from "react";
import PropTypes from 'prop-types';
import AnimateOnScroll from "../components/AnimateOnScroll";

const ImageStrip = ({ id, image }) => (
  <section id={id} className="w-full">
    <AnimateOnScroll>
      <img
        src={image}
        alt="Decorative strip"
        className="h-40 md:h-72 w-full object-cover object-[100%_25%]"
      />
    </AnimateOnScroll>
  </section>
);

ImageStrip.propTypes = {
  id: PropTypes.string,
};

export default ImageStrip;